import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Link from '../../components/site/typography/Link'
import Button from '../../components/site/Button/Button'
import MenuItem from './MenuItem'
import PartnerContactModal from '../../components/site/Partner/PartnerContactModal'
//import PromotionalModal from '../../components/site/PromotionalModal/PromotionalModal'
import { redirectWithCookies } from '../../utils/Utm'
//import TopBar from './TopBar'

import './NewMenu.scss'

const softwareSubItems = [
    {
        href: '/industrias',
        title: 'Veja como o Mercos pode potencializar sua Indústria.',
        content: 'Indústrias',
        url: '/images/icon-industrias.svg'
    },
    {
        href: '/distribuidoras',
        title: 'Veja como o Mercos pode potencializar sua Distribuidora.',
        content: 'Distribuidoras',
        url: '/images/icon-distribuidoras.svg'
    },
    {
        href: '/representantes-comerciais',
        title: 'Veja como o Mercos pode potencializar o Representante Comercial.',
        content: 'Representantes',
        url: '/images/icon-representates.svg'
    }
],
    partnersSubItems = [
        {
            href: '/integracao-erp',
            title: 'Encontre o ERP ideal com integração ao Mercos.',
            content: 'ERPs integrados'
        },
        {
            href: '/parceiros',
            title: 'Conheça nosso programa de Parceiros.',
            content: 'Seja parceiro'
        },
    ],
    conteudoSubItems = [
        {
            href: 'https://blog.mercos.com/',
            title: 'Novidades no blog',
            content: 'Blog',
            target: '_blank'
        },
        {
            href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
            title: 'Mercoscast',
            content: 'Mercoscast',
            target: '_blank'
        },
    ],
    participantsSubItems = [
        {
            href: '/experience/ingressos',
            title: 'Comprar agora meu ingresso.',
            content: 'Ingressos'
        }, {
            href: '/experience/onde-ficar',
            title: 'Saiba onde ficar hospedado e quais as atividades da região.',
            content: 'Onde ficar'
        }, {
            href: '/experience/duvidas',
            title: 'Tire suas dúvidas sobre o Mercos Experience.',
            content: 'Dúvidas'
        },
    ],
    videosSubItems = [
        {
            href: '/mercoscast',
            title: 'Ouça nosso podcast.',
            content: 'Mercoscast'
        },
        {
            href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hUoq30m-PK8Zx-S-lDYExX-',
            title: 'Veja nosso Mercos Minuto',
            content: 'Mercos Minuto',
            target: '_blank'
        },
        {
            href: '/blog/lives',
            title: 'Assista nossas lives',
            content: 'Lives'
        }
    ]

class NewMenu extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openedMenu: false,
            whiteBackground: this.props.whiteBackground,
            compoundUtmUrl: '',
            showTopBarMargin: false,
            isOnTop: true,
        }
    }

    clickOpenMenu() {
        this.setState({ openedMenu: !this.state.openedMenu })
    }

    handleScroll = () => {
        const pixelsToShowMenuWhite = this.props.pixelsToShowMenuWhite || 50
        const scrolledFromTop = window.scrollY
        
        if (window.scrollY <= pixelsToShowMenuWhite) {
            this.setState({
                whiteBackground: this.props.whiteBackground || false,
                showTopBarMargin: false
            })
        } else {
            this.setState({
                whiteBackground: true,
                showTopBarMargin: false
            })
        }

        const isOnTop = scrolledFromTop === 0
        if (this.state.isOnTop !== isOnTop) {
            this.setState({ isOnTop })
        }
    }

    componentWillUnmount() {
        if (this.props.mutableMenu || this.props.whiteBackground) {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }

    componentDidMount() {
        if (this.props.mutableMenu || this.props.whiteBackground) {
            window.addEventListener('scroll', this.handleScroll)
        }
    }

    isTopBarVisible() {
        return this.state.showTopBarMargin && !this.props.removeTopBarMargin
    }

    getSiteMenu() {
        const whiteBg = this.state.whiteBackground
        const loginOnly = this.props.loginOnly

        return (
            <nav
                className={cx(
                    'new-navmenu navbar navbar-expand-lg navbar-transition menu-lateral effect-1',
                    whiteBg ? 'new-navmenu-white' : 'menu-topo-transparente',
                    this.props.logoOnly ? 'logo-only' : '',
                    this.props.purple && 'purple',
                    this.isTopBarVisible() && 'top-bar-margin',
                    this.state.openedMenu && 'opened',
                    { 'fixed-top': this.props.fixed },
                    { 'menu-on-top': this.state.isOnTop }
                )}
            >   <div className={cx('container menu-nav-container new-home-container')}>
                    <Link href='/' className='navbar-logo' title='Ir para a página principal.'>
                        <img
                            className={this.state.openedMenu ? 'new-menu-logo-mercos opened' : 'new-menu-logo-mercos'}
                            alt="Logomarca Mercos"
                            src={
                                this.state.openedMenu
                                    ? "/images/site/logo-minimal.svg"
                                    : (whiteBg ? "/images/site/logo-mercos-colored.svg" : "/images/logo_mercos_footer.svg")
                            }
                        />
                    </Link><div className="nav-close-wrapper" onClick={() => this.clickOpenMenu()}>
                        {this.state.openedMenu ? (
                            'FECHAR'
                        ) : 'MENU'}
                    </div>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <img src={this.state.openedMenu ? '/images/icon-close.svg' : `/images/icon-hamburger-${whiteBg ? 'black' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            {!loginOnly && <Fragment>
                                <MenuItem color='linkBlack' className='highlight' href='/' title='Página inicial da Mercos.'>Home</MenuItem>
                                <MenuItem color='linkBlack' href='.' title='Conheça o Mercos.' newSubItems={softwareSubItems}>Software</MenuItem>
                                <MenuItem color='linkBlack' className='highlight' href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem color='linkBlack' href='.' title='Saiba mais sobre nossos parceiros.' newSubItems={partnersSubItems}>Integrações</MenuItem>
                                <MenuItem color='linkBlack' href='.' title='Conheça nosso conteúdo.' newSubItems={conteudoSubItems}>Conteúdo</MenuItem>
                            </Fragment>}
                            <MenuItem type='button' className='button-menu-mobile' model='success' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos.'>comece grátis</MenuItem>
                            <MenuItem color='linkBlack' model='outline' className={cx('highlight', 'link-menu')} onClick={() => redirectWithCookies('https://app.mercos.com/login/')} href='#' title='Acesse o Mercos!'>Ja possui conta? acesse aqui</MenuItem>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav new-home-navbar'>
                            {!loginOnly && <Fragment >
                                <MenuItem color='linkLight' href='.' title='Conheça o Mercos.' newSubItems={softwareSubItems}>Software</MenuItem>
                                <MenuItem color='linkLight' className='highlight' href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem color='linkLight' href='.' title='Saiba mais sobre nossos parceiros.' newSubItems={partnersSubItems}>Integrações</MenuItem>
                                <MenuItem color='linkLight' href='.' title='Conheça nosso conteúdo.' newSubItems={conteudoSubItems}>Conteúdo</MenuItem>
                            </Fragment>}

                            <MenuItem className={'button-menu-home'} shake type='button' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos!'>comece grátis</MenuItem>
                            <MenuItem
                                {...(whiteBg && { color: 'linkLight' })}
                                className={cx('menu-item-enter', !whiteBg && 'menu-item-enter-white')}
                                shake
                                onClick={() => redirectWithCookies('https://app.mercos.com/login/')}
                                href='#'
                                title='Acesse o Mercos!'
                            >
                                Entrar
                            </MenuItem>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    render() {
        return (
            <Fragment>

                {
                    this.getSiteMenu()
                }

            </Fragment>
        )
    }
}

NewMenu.propTypes = {
    bigPadding: PropTypes.bool,
    whiteBackground: PropTypes.bool,
    logoOnly: PropTypes.bool,
    mutableMenu: PropTypes.bool,
    pixelsToShowMenuWhite: PropTypes.number,
    isNewHome: PropTypes.bool,
    fixed: PropTypes.bool, // Added prop type for fixed
    topBarType: PropTypes.string,
    removeTopBarMargin: PropTypes.bool
}

NewMenu.defaultProps = {
    bigPadding: false,
    whiteBackground: false,
    logoOnly: false,
    mutableMenu: false,
    pixelsToShowMenuWhite: 100,
    fixed: true, // Default value for fixed
    topBarType: '',
    removeTopBarMargin: false
}

export default NewMenu



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/NewMenu.jsx